module.exports = __webpack_public_path__ + "img/sidebar_flood_sensor.d94db85c.svg";